// @ts-nocheck

/**
 * * `original` - Original Generation
 * `generate` - Full Regeneration
 * `edit` - Semantic Edit
 * `upload` - User Upload
 */
export type LayerImageVersionGenerationModeEnum =
  typeof LayerImageVersionGenerationModeEnum[keyof typeof LayerImageVersionGenerationModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LayerImageVersionGenerationModeEnum = {
  original: "original",
  generate: "generate",
  edit: "edit",
  upload: "upload",
} as const;
